import React, { useEffect } from 'react'
import Scrollbars from 'react-custom-scrollbars'

import { GALLERY_SLICED_OFFSET } from 'app/constants/api/galleries'
import { ACTIVITY_VIDEO } from 'app/constants/gallery'
import GalleryLoader from '../GalleryLoader'
import GalleryItem from '../GalleryItem'
import GalleryNoItems from '../GalleryNoItems'

const GalleryItems = ({
  pending,
  images,
  selectImage,
  setCropperImage,
  currentImage,
  innerModifier,
  showModal,
  minImageWidth,
  minImageHeight,
  getImage = image => (image.toJS ? image.toJS() : image),
  getKey = image => (image.get ? image.get('id') : image.id),
  getCaption,
  isSkipCropper,
  increaseLazyLoaded,
  fetchVideosByPage,
  currentPage,
}) => {
  const isVideo = innerModifier === ACTIVITY_VIDEO
  if (!isVideo) {
    useEffect(() => {
      increaseLazyLoaded({ value: GALLERY_SLICED_OFFSET })
    }, [])
  }
  return (
    <Scrollbars
      autoHeight
      autoHeightMax={252}
      onScrollFrame={values => {
        if (values.top === 1 && !isVideo) {
          increaseLazyLoaded()
        }
        if (values.top === 1 && isVideo) fetchVideosByPage(currentPage + 1)
      }}
    >
      {pending ? (
        <GalleryLoader />
      ) : images.size !== 0 ? (
        images.map(image => {
          return (
            <GalleryItem
              key={getKey(image)}
              image={getImage(image)}
              currentImage={currentImage}
              onItemClick={(image, width, height) => {
                setCropperImage(image)
                if ((width === minImageWidth && height === minImageHeight) || isSkipCropper) {
                  selectImage({ ...image, width, height })
                } else {
                  showModal(image)
                }
              }}
              minImageWidth={minImageWidth}
              minImageHeight={minImageHeight}
              caption={getCaption && getCaption(image)}
              innerModifier={innerModifier}
            />
          )
        })
      ) : (
        <GalleryNoItems />
      )}
    </Scrollbars>
  )
}

export default GalleryItems
